import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { WeGoConfig } from './../../shared/config';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  AfterViewInit,
  SimpleChange,
  OnChanges
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { BookingService } from './../models/booking.service';
import { SearchBookingModel } from './../models/search-booking.model';
import { OrganizationDropDownModel } from '../../organization/models/organization.model';
import { DriverAdminService } from './../../driveradmin/models/driveradmin.service';

const moment = require('moment');
@Component({
  selector: 'wego-search-booking',
  template: require('../views/search-booking.component.html'),
  styles: [
    `
      .box-body {
        padding: 0px 10px 10px;
      }
    `
  ],
  providers: [DriverAdminService]
})

export class SearchBookingComponent implements OnInit, AfterViewInit, OnChanges {
  @Output('OnSearch') onSearch = new EventEmitter();
  @Input('SearchBookingModel')
  model: SearchBookingModel = new SearchBookingModel();
  @ViewChild('flatPickrConfigFromDate')
  public flatPickrConfigFromDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigToDate')
  public flatPickrConfigToDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigEndDate')
  public flatPickrConfigEndDate: FlatPickrDirective;

  @ViewChild('flatPickrConfigFromDateSpl')
  public flatPickrConfigFromDateSpl: FlatPickrDirective;
  @ViewChild('flatPickrConfigToDateSpl')
  public flatPickrConfigToDateSpl: FlatPickrDirective;

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;

  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigEnd: FlatPickrModel;

  flatPickrConfigFromSpl: FlatPickrModel;
  flatPickrConfigToSpl: FlatPickrModel;

  isLoading: boolean;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  message: string;
  isenableTime: boolean;
  specialPeriodList: any[];
  searchRetainModal: any;
  private startDateTimeByTimeZone: string;
  public language:string='en';

  constructor(
    private bookingService: BookingService,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private driverAdminService: DriverAdminService
  ) { }

  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigEnd = this.SetDefaultFlatPickrConfig(true);

    this.flatPickrConfigFromSpl = this.SetDefaultSplPerFlatPickrConfig(true);
    this.flatPickrConfigToSpl = this.SetDefaultSplPerFlatPickrConfig(true);

    if (this.model) {
      this.searchRetainModal = Object.assign({}, this.model);
      this.OnOrganizationChange();
    }
  }
  ngOnChanges(changes: any) {
    if ((changes && changes.model && changes.model.currentValue && !changes.model.currentValue.isRegularbooking)) {
      this.ClearTimeSpanForSpecialPeriod();
    }
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  private SetDefaultSplPerFlatPickrConfig(
    //isDaySpecialPeriod: boolean,
    isDateOnly?: boolean
  ) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    // if (!isDaySpecialPeriod) {
    //   flatPickrConfig.enable = [
    //     (date: any) => {
    //       // return true to disable
    //       return date.getDay() === 6 || date.getDay() === 0;
    //     }
    //   ];
    // } else {
    //   flatPickrConfig.disable = [
    //     (date: any) => {
    //       // return true to disable
    //       return date.getDay() === 6 || date.getDay() === 0;
    //     }
    //   ];
    // }
    return flatPickrConfig;
  }

  public OnFromDateChange(value: string) {
    console.log(value);
    console.log(this.model.endDateTime);
    if (value && this.model.isRegularbooking) {
      let format = 'DD-MM-YYYY HH:mm';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      let endDateVal = moment(value, format);
      // let recurringEndDate = moment(this.model.endDateTime, format).toDate();
      if (endDate <= newDate) {
        if (this.isenableTime) {
          endDateVal = endDateVal.add('H', 1);
        } else {
          endDateVal = endDateVal.add('d', 1);
        }
        // recurringEndDate = endDateVal.toDate();
        this.flatPickrConfigToDate.ChangeValue(
          endDateVal.format('DD-MM-YYYY HH:mm')
        );
      }
      this.flatPickrConfigToDate.SetOption('minDate', newDate);
      // if (this.flatPickrConfigEndDate) {
      //   this.flatPickrConfigEndDate.SetOption("minDate", recurringEndDate);
      // }
    }
  }

  public OnDayStartDateChange(value: string) {
    console.log(value);
    console.log(this.model.endDateTime);
    if (value) {
      let format = 'DD-MM-YYYY';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      let endDateVal = moment(value, format);
      // let recurringEndDate = moment(this.model.endDateTime, format).toDate();
      if (endDate <= newDate) {
        endDateVal = endDateVal.add('d', 0);
        // recurringEndDate = endDateVal.toDate();
        this.flatPickrConfigToDateSpl.ChangeValue(
          endDateVal.format('DD-MM-YYYY')
        );
      }
      this.flatPickrConfigToDateSpl.SetOption('minDate', newDate);
      // if (this.flatPickrConfigEndDate) {
      //   this.flatPickrConfigEndDate.SetOption("minDate", recurringEndDate);
      // }
    }
    //this.ChangeDateTimeForInputModel();
  }

  public SetPickerValue(key: string, value: string) {
    if (key == 'SEARCH_FROM') {
      this.flatPickrConfigFromDate.ChangeValue(value);
    }
    if (key == 'SEARCH_TO') {
      this.flatPickrConfigToDate.ChangeValue(value);
    }
  }

  public ClearErrorModel() {
    this.errorModel = [];
  }

  private ChangeDateTimeForInputModel() {
    if (!this.model.isRegularbooking) {
      this.model.startDateTime = moment()
        .add('d', 1)
        .format('DD-MM-YYYY 00:00');
      this.model.endDateTime = moment(
        // this.model.startDateTime,
        // 'DD-MM-YYYY 00:00'
      )
        .add('d', 1)
        .format('DD-MM-YYYY 00:00');
      this.ClearTimeSpanForSpecialPeriod();
    } else {
      // if (!this.isenableTime) {
      //   this.model.startDateTime = moment()
      //     .add('d', 1)
      //     .format('DD-MM-YYYY 00:00');
      //   this.model.endDateTime = moment(
      //     this.model.startDateTime,
      //     'DD-MM-YYYY 00:00'
      //   )
      //     .add('d', 1)
      //     .format('DD-MM-YYYY 00:00');
      // } else {
      //   this.model.startDateTime = moment()
      //     .add('m', 5)
      //     .format('DD-MM-YYYY HH:mm');
      //   this.model.endDateTime = moment()
      //     .add('H', 1)
      //     .add('m', 5)
      //     .format('DD-MM-YYYY HH:mm');
      // }
      this.model.startDateTime = this.isenableTime
        ? moment(this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
          .add(5, 'minute')
          .format('DD-MM-YYYY HH:mm')
        : moment(this.startDateTimeByTimeZone)
          .add(1, 'd')
          .format('DD-MM-YYYY 00:00');
      this.model.endDateTime = this.isenableTime
        ? moment(this.model.startDateTime, 'DD-MM-YYYY HH:mm')
          .add(1, 'hour')
          .format('DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm')
        : moment(this.model.startDateTime)
          .add(1, 'd')
          .format('DD-MM-YYYY 00:00');
    }
  }

  private ClearTimeSpanForSpecialPeriod() {
    this.model.startDateTime = this.model.startDateTime.substring(0, 10);
    this.model.endDateTime = this.model.endDateTime.substring(0, 10);
  }

  private OnSearch(forms: any) {
    // if (!this.geoLocation) {
    //   this.geoLocationError = this.translate.instant('LblGeoLocationError');
    // }
    // else {
    //this.geoLocationError = '';

    let tempModel = Object.assign({}, this.model);

    if (!tempModel.isRegularbooking) {
      tempModel.startDateTime =
        tempModel.startDateTime.length <= 10
          ? tempModel.startDateTime + ' 00:00'
          : tempModel.startDateTime;
      tempModel.endDateTime =
        tempModel.endDateTime.length <= 10
          ? tempModel.endDateTime + ' 00:00'
          : tempModel.endDateTime;
    }

    this.CalculateBookingDuration(tempModel);
    tempModel.totalBookingDuration = this.model.totalBookingDuration;
    this.message = '';
    this.errorModel = null;
    this.isLoading = true;

    this.bookingService.GetVehicleOverview(tempModel).subscribe(
      res => {
        this.isLoading = false;
        if (!res.data) {
          this.errorModel = res.error;
        } else {
          if (res.data.length > 0) {
            this.onSearch.emit({
              SearchModel: tempModel,
              VehicleOverview: res.data
            });
          } else {
            this.message = res.error; //this.translate.instant('LblNoMatchingVehicle');
            // if (!this.model.isRegularbooking) {
            //   this.ClearTimeSpanForSpecialPeriod();
            // }
          }
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
        // if (!this.model.isRegularbooking) {
        //   this.ClearTimeSpanForSpecialPeriod();
        // }
      }
    );

    //}
  }

  // public GetAddress(place: Object) {
  //   // this.geoLocation = place['address'] != '' ? true : false;
  //   // this.model.companyGeoLocationLatitude = place['lat'];
  //   // this.model.companyGeoLocationLatitude = place['log'];
  //   this.model.sourceLocation = place['useraddressInput'];
  // }

  public CalculateBookingDuration(searchModel: SearchBookingModel) {
    let format = 'DD-MM-YYYY HH:mm';
    let stDate = moment(searchModel.startDateTime, format).toDate();
    let enDate = moment(searchModel.endDateTime, format).toDate();
    // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
    //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
    // }
    let diffMs = enDate - stDate;
    var diffDays = Math.floor(diffMs / 86400000); // days
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);

    if (diffDays > 0) {
      this.model.totalBookingDuration =
        diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
    } else if (diffDays == 0 && diffHrs > 0) {
      this.model.totalBookingDuration = diffHrs + ' Hours ' + diffMins + ' Min';
    } else if (diffDays == 0 && diffHrs == 0) {
      this.model.totalBookingDuration = diffMins + ' Min';
    }
    console.log(this.model.totalBookingDuration);
  }

  private SuccessSelectDriverModal($event: any) {
    this.model.driverHashId = $event.DriverHashID;
    this.model.driverName = $event.DriverName;
    this.language = $event.instanceLanguage;
    this.model.recurringEndDateTime = '';

    this.GetOrganizationList();
  }

  private OnOrganizationChange() {
    if (this.model.organizationIdHashID) {
      this.SelectedDriverDetail();
      this.AllowRecurringBooking();
      // this.AllowTimeForBooking();
      this.GetSpecialPeriodList();
      /// this.handleChange(true, 'REGULAR', '');
      console.log(this.specialPeriodList);
    }
  }

  public SelectedDriverDetail() {
    this.driverAdminService.GetCurrentDriverDetailByDriverId(this.model.driverHashId).subscribe(
      (res: any) => {
        // this.isLoading = false;
        if (res.data) {
          this.startDateTimeByTimeZone = res.data.startDateTime;
          this.AllowTimeForBooking();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        // this.isLoading = false;
      }
    );
  }

  private AllowRecurringBooking() {
    this.bookingService
      .AllowRecurringBooking(
        this.model.driverHashId,
        this.model.organizationIdHashID
      )
      .subscribe(
        res => {
          this.model.isRecurringBookingAllow = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  private GetOrganizationList() {
    this.bookingService.GetOrganizationList(this.model.driverHashId).subscribe(
      res => {
        this.model.organizationList = res.data;
        //this.model.organizationIdHashID = '';
        if (
          this.model &&
          this.model.organizationList &&
          this.model.organizationList.length == 1
        ) {
          this.model.organizationIdHashID = this.model.organizationList[0].organizationMasterHashId;
          this.OnOrganizationChange();
        } else {
          this.model.organizationIdHashID = '';
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private GetSpecialPeriodList() {
    this.bookingService
      .GetSpecialPeriodList(this.model.organizationIdHashID, this.model.driverHashId)
      .subscribe(
        res => {
          this.specialPeriodList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        },
        () => {
          //   this.handleChange(true, 'REGULAR', '');
        }
      );
  }

  private AllowTimeForBooking() {
    this.bookingService
      .AllowTimeForBooking(
        this.model.driverHashId,
        this.model.organizationIdHashID
      )
      .subscribe(
        res => {
          this.isenableTime = res.data;
          // this.ChangeDateTimeForInputModel();
          if (!this.model.isRegularbooking) {
            this.model.startDateTime = moment()
              .add('d', 1)
              .format('DD-MM-YYYY 00:00');
            this.model.endDateTime = moment(
              // this.model.startDateTime,
              // 'DD-MM-YYYY 00:00'
            )
              .add('d', 1)
              .format('DD-MM-YYYY 00:00');
            this.ClearTimeSpanForSpecialPeriod();
          } else {
            // if (!this.isenableTime) {
            //   this.model.startDateTime = moment()
            //     .add('d', 1)
            //     .format('DD-MM-YYYY 00:00');
            //   this.model.endDateTime = moment(
            //     this.model.startDateTime,
            //     'DD-MM-YYYY 00:00'
            //   )
            //     .add('d', 1)
            //     .format('DD-MM-YYYY 00:00');
            //   this.model.recurringPeriod = 'WEEKLY';
            // } else {
            //   this.model.startDateTime = moment()
            //     .add('m', 5)
            //     .format('DD-MM-YYYY HH:mm');
            //   this.model.endDateTime = moment()
            //     .add('H', 1)
            //     .add('m', 5)
            //     .format('DD-MM-YYYY HH:mm');
            //   this.model.recurringPeriod = 'DAILY';
            // }
            console.log(this.startDateTimeByTimeZone);
            this.model.startDateTime = this.isenableTime
              ? moment(this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
                .add(5, 'minute')
                .format('DD-MM-YYYY HH:mm')
              : moment(this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
                .add(1, 'd')
                .format('DD-MM-YYYY 00:00');
            this.model.endDateTime = this.isenableTime
              ? moment(this.model.startDateTime, 'DD-MM-YYYY HH:mm')
                .add(1, 'hour')
                .format('DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm')
              : moment(this.model.startDateTime, 'DD-MM-YYYY HH:mm')
                .add(1, 'd')
                .format('DD-MM-YYYY 00:00');
            this.model.recurringPeriod = this.isenableTime ? 'DAILY' : 'WEEKLY';
          }
          if (this.model.isRegularbooking) {
            this.flatPickrConfigFromDate.ToggleTimePicker(this.isenableTime);
            this.flatPickrConfigToDate.ToggleTimePicker(this.isenableTime);
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        },
        () => {
          if (this.searchRetainModal) {
            // this.model.startDateTime = this.searchRetainModal.startDateTime;
            // this.model.endDateTime = this.searchRetainModal.endDateTime;
          }
          if (!this.model.isRegularbooking) {
            this.ClearTimeSpanForSpecialPeriod();
          }
        }
      );
  }

  public PickupLocation($event: any) {
    this.model.pickupAddress = $event.address;
    this.model.pickupLat = $event.lat;
    this.model.pickupLong = $event.long;
  }

  public ResetLocationField() {
    this.model.pickupAddress = '';
    this.model.pickupLat = 0;
    this.model.pickupLong = 0;
  }

  public handleChange(
    changeVal: any,
    periodType: any,
    contractTypeHashID: string
  ) {
    this.model.isRegularbooking = changeVal;
    this.model.specialPeriodType = periodType;
    this.model.contractTypeHashId = contractTypeHashID;
    this.model.isRecurring = false;
    this.model.recurringEndDateTime = '';

    this.ChangeDateTimeForInputModel();

    if (!this.model.isRegularbooking && this.flatPickrConfigToDateSpl) {
      this.flatPickrConfigToDateSpl.ChangeValue(this.model.endDateTime);
    }
  }

  ngAfterViewInit() {
    //this.OnFromDateChange(this.model.startDateTime);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/search-booking.component.ts